module.exports = __webpack_public_path__ + "static/media/forward-chevron.dbaa8dc0.svg";